/* --------- VH CODE --------- */
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// AGB - DSGVO CHECKBOX für CHECKOUT
// AGB - DSGVO CHECKBOX für CHECKOUT (VH CODE)
(function () {
  function initAgbCheck() {
    document.addEventListener('click', function (e) {
      if (e.target && e.target.getAttribute('name') === 'checkout') {
        const form = e.target.closest('form');
        if (!form) return;

        const checkbox = form.querySelector('.vh-agb-input');
        if (checkbox && !checkbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert("Nehmen Sie unsere AGB und Datenschutzerklärung zur Kenntnis um fortzufahren.");
          return false;
        }
      }
    }, true); // Use capture phase to intercept before theme scripts
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgbCheck);
  } else {
    initAgbCheck();
  }

  /* --------- VH CODE --------- */
  /**
   * Ersetzt Platzhalter [[VAR]] durch die Theme-Einstellungen via JavaScript.
   * Dies ist notwendig, da Shopify auf Policy-Seiten keinen Zugriff auf alle Liquid-Objekte erlaubt.
   */
  function initVhPlaceholders() {
    const vars = (window.theme && window.theme.vhContentVariables) ? window.theme.vhContentVariables : {};
    if (Object.keys(vars).length === 0) return;

    // Nur in relevanten Containern suchen (Performance & Sicherheit)
    const containers = document.querySelectorAll('.rte, .shopify-policy__body, .page__content, .page__description');
    
    containers.forEach(container => {
      let html = container.innerHTML;
      let hasChanged = false;

      for (const [key, value] of Object.entries(vars)) {
        if (html.includes(key) && value) {
          // Globaler Replace für den Platzhalter
          const regex = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
          html = html.replace(regex, value);
          hasChanged = true;
        }
      }

      if (hasChanged) {
        container.innerHTML = html;
      }
    });
  }

  // Sofort ausführen und bei DOMContentLoaded sicherheitshalber nochmal
  initVhPlaceholders();
  document.addEventListener('DOMContentLoaded', initVhPlaceholders);
  /* --------- VH CODE --------- */
})();

